import React from 'react';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import styled from '@emotion/styled';

import ActionsMenuButton from './ActionsMenuButton';
import ActionButton from './ActionButton';

import SpinnerBlock from '../../../common/SpinnerBlock';
import Lock from '../../../common/Lock';

import {
  getYandexStoreImageMin,
  checkOrderConfirmation,
  getProductEncodedUrl,
} from '../../../../helpers';

import { TAG_COLORS } from '../../../../config';
import Toogle from '../../../common/Toogle';
import DisplayMoreWrapper from '../../../common/DisplayMoreWrapper';

const Wrapper = styled('div')`
  box-shadow: none;
  border: 1px solid #ebebeb;

  .more-btn {
    border-bottom: 1px solid #dee2e6;
    border-top: none;
  }

  .dropdown-menu {
    position: absolute;
    will-change: transform;
    top: 0px;
    right: 0px;
    left: unset;
    transform: translate3d(0px, 35px, 0px);

    .dropdown-item {
      cursor: pointer;
      padding-left: 5px;
      padding-right: 5px;
      &.help-tooltip-wrapper {
        margin-left: 0;
        color: #bcbdc1 !important;
        background-color: transparent !important;
      }
    }
  }

  .permission {
    .help-tooltip {
      left: -10px;
    }
    margin-top: 7px;
    margin-right: 20px;
  }

  .tags-wrapper {
    position: absolute;
    padding: 0 1.5rem;
    left: 0;
    top: 0;
    display: flex;

    .tag {
      border-radius: 0 0 10px 10px;
      margin: 0 10px 0 0;
      height: 16px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      font-size: 8px;
      color: white;
      cursor: pointer;

      :last-of-type {
        margin: 0;
      }
    }
  }

  .head-row {
    padding: 0 16px 16px;
    border-bottom: 2px solid #f2f5f7;
    display: flex;
    flex-wrap: nowrap;

    .btn-group-left {
      margin-left: auto;
    }
  }

  .main-item {
    display: grid;
    padding: 16px;
    border-bottom: 2px solid #f2f5f7;
    display: flex;

    .image-wrapper {
      flex: 0 0 36px;
      height: 36px;
      margin-right: 16px;

      .image-td {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px;
      }
    }

    .data-wrapper {
      flex-grow: 1;

      .content-sum-wrapper {
        display: flex;

        .content-wrapper {
          flex-grow: 1;
          padding-right: 30px;

          .item-name {
            color: inherit;
            font-weight: 600;
          }

          .item-article {
            font-size: 11px;
          }

          .item-subname {
            font-size: 11px;
            color: #98a6ad;
            margin-bottom: 4px;

            &:last-of-type {
              margin-bottom: 0;
            }
          }
        }

        .sum-wrapper {
          flex: 0 0 45px;
          color: #7e2199;
          &.disabled {
            color: #72747b;
          }
        }
      }

      .item-status {
        font-size: 10px;
        text-transform: uppercase;
        padding: 8px 0 0;

        &.item-status-green {
          color: #1abc9c;
        }

        &.item-status-orange {
          color: #f7b84b;
        }

        span {
          display: block;
          text-transform: none;
          color: #98a6ad;
        }
      }

      .multiple-item-status {
        .item-status-green {
          position: relative;
          padding-bottom: 8px;

          ::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: calc(100% + 16px);
            border-bottom: 1px solid #f2f5f7;
          }
        }
      }
    }
  }

  .list-edits-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    border-bottom: 2px solid #f2f5f7;

    .add-item {
      color: #7e57c2;
    }

    .refresh-reserve {
      color: #f772a7;
      &.disabled {
        color: #7b7a7a;
        cursor: initial;
      }
    }
  }

  .totals {
    padding: 16px;
  }

  .alert {
    margin: 0 0 16px !important;
  }

  .reserve-toogle {
    width: 200px;
    margin: 0 0 20px;
    span {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #6e768e;
    }
  }
`;

const MobileMainBlock = (props) => {
  const {
    loadingOrder,
    currentOrder,
    handleEditTag,
    isNew,
    permissions,
    refreshReservePermission,
    handleUpdateDeliveryResult,
    handleConfirmation,
    isManualWarehouse,
    loadingSticker,
    loadingUploadFbmDocsButton,
    handlePacking,
    handleSendPackingControl,
    handleDownloadSticker,
    showActions,
    showUploadFbmDocsButton,
    haveProductsWithoutReserve,
    setShowActions,
    handleUploadToFulfillment,
    handleSetDelivery,
    handleAcceptReturn,
    handleRefreshReserve,
    handleCancel,
    handleCopyOrder,
    handleImportFromExcel,
    sortedData,
    handleOpenItemModal,
    currencySymbol,
    getItemStatusLabel,
    itemsStatuses,
    handleRemoveItem,
    handleAddItem,
    allQuantity,
    sum,
    factSum,
    getTotalNds,
    haveProducts,
    getNdsValue,
    history,
    getItemStatus,
    itemsEditablePermission,
    handleAddTag,
    handleSendEmail,
    handleNewTicket,
    handleOpenEditSale,
    handleOpenPhoneCallBack,
    handleUploadFbmDocsButton,
    currentWarehouse,
    handleExportExcel,
    defaultReserveOrders,
    handleChangeNeedReserve,
    handleInvoice,
    hasDiscount,
    getPriceBeforeDiscount,
    actualizeOrder,
    worksheetDataRequirements,
  } = props;

  return (
    <Wrapper className="card-box card-box-main">
      <SpinnerBlock show={loadingOrder} />
      <div className="tags-wrapper">
        {currentOrder.tags && currentOrder.tags.length ? (
          currentOrder.tags
            .map((tag) => {
              const currentColor = TAG_COLORS.find((item) => item.id === tag.color);
              return (
                <label
                  className="tag"
                  style={{ background: currentColor.code }}
                  onClick={(evt) => handleEditTag(evt, currentOrder)}
                >
                  {tag.name}
                </label>
              );
            })
            .slice(0, 4)
        ) : (
          <label
            className="tag"
            style={{ background: `#d8e0e4` }}
            onClick={(evt) => handleAddTag(evt, currentOrder)}
          >
            Новая метка
          </label>
        )}
      </div>
      {!defaultReserveOrders ? (
        <div className="col-3">
          <h4 className="reserve-toogle">
            <Toogle
              id="needReserve"
              onChange={(e) => handleChangeNeedReserve(e.target.checked)}
              label="Резервировать товары"
              checked={currentOrder.needReserve}
            />
          </h4>
        </div>
      ) : null}
      <div className="head-row">
        {!isNew ? (
          <>
            <div className="permission">
              {!itemsEditablePermission.value ? (
                <Lock reason={itemsEditablePermission.reason} />
              ) : null}
            </div>
            <ActionButton
              withoutPermission
              classType="btn-danger"
              text="Задать вопрос"
              action={() => handleNewTicket()}
            />

            {currentOrder.delivery &&
            currentOrder.delivery.type === 'SELF_PICKUP' &&
            currentOrder.status === 'ORDER_INFO_PACKED' ? (
              <ActionButton
                permissions={permissions}
                permissionKey="DELIVER_SELF_PICKUP"
                classType="btn-success"
                text="Выдан получателю"
                action={() => handleUpdateDeliveryResult('DELIVERED')}
              />
            ) : null}

            {!checkOrderConfirmation(currentOrder) ? (
              <ActionButton
                permissions={permissions}
                permissionKey="NEED_CONFIRM"
                classType="btn-warning"
                text="Подтвердить"
                action={handleConfirmation}
              />
            ) : null}

            {isManualWarehouse && currentOrder.status === 'ORDER_INFO_READY_TO_PACK' ? (
              <ActionButton
                permissions={permissions}
                permissionKey="PACK"
                loading={loadingSticker}
                disabled={loadingSticker}
                classType="btn-warning"
                text="На упаковку"
                action={handlePacking}
              />
            ) : null}

            {isManualWarehouse &&
            currentOrder.status === 'ORDER_INFO_IN_PACKING' &&
            currentOrder.packings &&
            currentOrder.packings.length ? (
              <ActionButton
                permissions={permissions}
                permissionKey="PACK_CONTROL"
                classType="btn-warning"
                text="Упакован"
                action={handleSendPackingControl}
              />
            ) : null}

            {showUploadFbmDocsButton ? (
              <ActionButton
                withoutPermission
                classType="btn-warning"
                text="Документы загружены"
                loading={loadingUploadFbmDocsButton}
                action={handleUploadFbmDocsButton}
              />
            ) : null}

            <div className="btn-group-left">
              {isManualWarehouse &&
              ['ORDER_INFO_IN_PACKING', 'ORDER_INFO_PACKED', 'ORDER_INFO_SHIPPED'].indexOf(
                currentOrder.status,
              ) !== -1 ? (
                <ActionButton
                  withoutPermission
                  permissions={permissions}
                  //permissionKey=""
                  classType="btn-light"
                  className="ml-1"
                  icon="fe-printer"
                  text="Стикер"
                  loading={loadingSticker}
                  disabled={loadingSticker}
                  action={handleDownloadSticker}
                />
              ) : null}
              <ActionsMenuButton
                shorted
                isNew={isNew}
                currentOrder={currentOrder}
                showActions={showActions}
                haveProductsWithoutReserve={haveProductsWithoutReserve}
                permissions={permissions}
                setShowActions={setShowActions}
                handleUploadToFulfillment={handleUploadToFulfillment}
                handleSetDelivery={handleSetDelivery}
                handleAcceptReturn={handleAcceptReturn}
                handleRefreshReserve={handleRefreshReserve}
                handleCancel={handleCancel}
                handleUpdateDeliveryResult={handleUpdateDeliveryResult}
                handleCopyOrder={handleCopyOrder}
                handleImportFromExcel={handleImportFromExcel}
                handleSendEmail={handleSendEmail}
                handleOpenEditSale={handleOpenEditSale}
                handleOpenPhoneCallBack={handleOpenPhoneCallBack}
                currentWarehouse={currentWarehouse}
                handleExportExcel={handleExportExcel}
                defaultReserveOrders={defaultReserveOrders}
                handleInvoice={handleInvoice}
                actualizeOrder={actualizeOrder}
                worksheetDataRequirements={worksheetDataRequirements}
              />
            </div>
          </>
        ) : null}
      </div>
      <DisplayMoreWrapper array={sortedData} btnClassName="more-btn">
        {({ item, itemIndex }) => (
          <div key={`${item.productId}=${item.variantId}`} className="main-item">
            <div className="image-wrapper">
              {item.variantId !== 'delivery' ? (
                <img className="image-td" alt="" src={getYandexStoreImageMin(item.img, 100)} />
              ) : null}
            </div>
            <div className="data-wrapper">
              <div className="content-sum-wrapper">
                <div className="content-wrapper">
                  {item.variantId !== 'delivery' ? (
                    <>
                      <Link
                        to={{
                          pathname: getProductEncodedUrl(
                            item.productId,
                            item.productVariantCount > 1 ? item.variantId : undefined,
                          ),
                          state: { customBackLink: history.location.pathname },
                        }}
                        className="item-name"
                      >
                        {item.name}
                      </Link>
                      {item.article ? (
                        <div className="item-article">{`Арт.: ${item.article}`}</div>
                      ) : null}
                      <div className="item-subname">{`${item.variantId || item.productId || ''} ${
                        item.variantExtId ? '(' + item.variantExtId + ')' : ''
                      }`}</div>
                    </>
                  ) : (
                    <>
                      <div className="item-name">{item.name}</div>
                      <div className="item-subname">{item.variantId}</div>
                    </>
                  )}
                </div>
                <div className={`sum-wrapper ${!itemsEditablePermission.value ? 'disabled' : ''}`}>
                  <div
                    className="item-sum"
                    onClick={() =>
                      itemsEditablePermission.value ? handleOpenItemModal(item, itemIndex) : false
                    }
                  >
                    {item.variantId !== 'delivery'
                      ? `${numeral(item.price * item.quantity).format('0.[00]')} ${currencySymbol}`
                      : `${numeral(item.price).format('0.[00]')} ${currencySymbol}`}
                  </div>
                  {item.variantId !== 'delivery' ? (
                    <>
                      <div
                        className="item-quantity"
                        onClick={() =>
                          itemsEditablePermission.value
                            ? handleOpenItemModal(item, itemIndex)
                            : false
                        }
                      >
                        {item.quantity} шт
                      </div>
                    </>
                  ) : (
                    <div className="delivery-placeholder">Услуга</div>
                  )}
                </div>
              </div>
              {item.variantId !== 'delivery'
                ? getItemStatusLabel(item.variantId, itemsStatuses, item.num)
                : null}
            </div>
          </div>
        )}
      </DisplayMoreWrapper>
      <div className="bottom-block">
        <div className="list-edits-wrapper">
          {itemsEditablePermission.value ? (
            <div className="add-item" onClick={handleAddItem}>
              + Новая позиция
            </div>
          ) : null}
          {(defaultReserveOrders || (!defaultReserveOrders && currentOrder.needReserve)) &&
          haveProductsWithoutReserve ? (
            <div
              className={`refresh-reserve ml-3 ${
                refreshReservePermission && !refreshReservePermission.value
                  ? 'disabled help-tooltip-wrapper'
                  : ''
              }`}
              onClick={
                refreshReservePermission && !refreshReservePermission.value
                  ? () => false
                  : handleRefreshReserve
              }
            >
              Обновить резерв
              {refreshReservePermission && !refreshReservePermission.value ? (
                <span className="help-tooltip">{refreshReservePermission.reason}</span>
              ) : null}
            </div>
          ) : null}
        </div>
        {sum ? (
          <div className="totals" style={{ paddingRight: 0 }}>
            <div className="items-total text-lg-right">
              <div>
                Сумма{hasDiscount ? ` до скидки` : ``}:{' '}
                {numeral(hasDiscount ? getPriceBeforeDiscount(sum) : sum).format('0.[00]')}{' '}
                {currencySymbol}
              </div>
              {currentOrder.promocode && currentOrder.promocodeAppliedDiscount ? (
                <div style={{ color: 'rgb(241, 85, 108)' }}>{`Промокод [${
                  currentOrder.promocode
                }]: -${numeral(currentOrder.promocodeAppliedDiscount).format(
                  '0.[00]',
                )} ${currencySymbol}`}</div>
              ) : null}
              {currentOrder.paymentMethodAppliedDiscount ? (
                <div style={{ color: 'rgb(241, 85, 108)' }}>{`Скидка за способ оплаты${
                  currentOrder.paymentMethodAppliedDiscount
                    ? ': ' +
                      numeral(currentOrder.paymentMethodAppliedDiscount).format('0.[00]') +
                      ' ' +
                      currencySymbol
                    : ''
                }`}</div>
              ) : null}
              {currentOrder.manualAppliedDiscount ? (
                <div style={{ color: 'rgb(241, 85, 108)' }}>{`Скидка вручную${
                  currentOrder.manualAppliedDiscount
                    ? ': ' +
                      numeral(currentOrder.manualAppliedDiscount).format('0.[00]') +
                      ' ' +
                      currencySymbol
                    : ''
                }`}</div>
              ) : null}
              <div
                style={{
                  fontWeight: 700,
                  textDecoration: sum != factSum ? 'line-through' : 'none',
                  marginTop: 8,
                }}
              >{`Итого: ${numeral(sum).format('0.[00]')} ${currencySymbol}`}</div>
              <div
                style={{ textDecoration: sum != factSum ? 'line-through' : 'none' }}
              >{`В том числе НДС: ${numeral(getTotalNds(currentOrder)).format(
                '0.[00]',
              )} ${currencySymbol}`}</div>
              {sum !== factSum ? (
                <>
                  <div
                    style={{
                      fontWeight: 700,
                      color: '#1abc9c',
                    }}
                  >{`Продано: ${numeral(factSum).format(`0.[00]`)} ${currencySymbol}`}</div>
                  <div style={{ color: `#1abc9c` }}>{`В том числе НДС: ${numeral(
                    getTotalNds(currentOrder, true),
                  ).format('0.[00]')} ${currencySymbol}`}</div>
                </>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
      {!haveProducts ? (
        <div
          className="alert alert-light mt-2"
          role="alert"
          style={{ display: `flex`, alignItems: `center` }}
        >
          <i className="fe-alert-circle mr-2" style={{ fontSize: '20px' }} />
          <span>Для разблокировки всех настроек заказа, добавьте товары</span>
        </div>
      ) : null}
    </Wrapper>
  );
};

export default MobileMainBlock;
